import { render } from "./material-link.vue?vue&type=template&id=44bff892&ts=true"
import script from "./material-link.vue?vue&type=script&lang=ts"
export * from "./material-link.vue?vue&type=script&lang=ts"

import "./material-link.vue?vue&type=style&index=0&id=44bff892&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__